// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__28jvQ","footer":"ModalFilter_footer__zBoIs"};